import { Box, Button, Stack } from "@mui/material"
import React, { Fragment } from "react"
import { PasswordField } from "../../../generic/GenericTextFields"
import { AlreadyHaveAccount } from "../generic/GenericDialogFooter"
import { useFormik } from "formik"
import { object } from "yup"
import { passwordAndConfrimPasswordValidations } from "../../../../helpers/genericFormValidations"
import { updatePassword } from "../../../../config/apisauce"
import { LOGIN_FORMS } from "../../../../enums/loginFormEnums"

export const ResetPasswordForm = ({ handleNextForm }) => {
  const resetPasswordHash = sessionStorage.getItem('resetPasswordHash');

  const handleReset = async (values) => {
    const response = await updatePassword({ ...values, hash: resetPasswordHash })
    if (response.ok) {
      handleNextForm(LOGIN_FORMS[4])
    }
  };

  const formik = useFormik({
    initialValues: {},
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape(passwordAndConfrimPasswordValidations),
    enableReinitialize: true,
    onSubmit: (values) => handleReset(values),
  });

  return (
    <Fragment>
      <Stack gap={4} mb={0.5}>
        <PasswordField
          value={formik.values.password}
          placeholder={'************'}
          label={'New Password'}
          error={Boolean(formik?.errors?.password)}
          helperText={formik?.errors?.password}
          handleChange={(value) => formik.setFieldValue('password', value)}
        />
        <PasswordField
          value={formik.values.password_confirmation}
          placeholder={'************'}
          label={'Confirm New Password'}
          error={Boolean(formik?.errors?.password_confirmation)}
          helperText={formik?.errors?.password_confirmation}
          handleChange={(value) => formik.setFieldValue('password_confirmation', value)}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }} onClick={() => formik.handleSubmit()}>Reset Password</Button>
        </Box>
        <AlreadyHaveAccount />
      </Stack>
    </Fragment>
  )
}